import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/products', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/products/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/products/${data.product_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient.delete(`/api/products/${id}`).then(response => Promise.resolve(response.data))
}

export const storePhoto = file => {
  return httpClient
    .post('/api/products/photos', file)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getPhoto = id => {
  return httpClient
    .get(`/api/products/${id}/photos`, {
      responseType: 'arraybuffer'
    })
    .then(response =>
      Promise.resolve(`data:image/jpg;base64,${new Buffer(response.data, 'binary').toString('base64')}`)
    )
    .catch(error => Promise.reject(error.response.data))
}

export const category = (Options = {}) => {
  return httpClient
    .get('/api/products/categories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const unitmeasure = (Options = {}) => {
  return httpClient
    .get('/api/products/unitmeasures', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const inventorytype = (Options = {}) => {
  return httpClient
    .get('/api/products/inventory-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const assemblyProduct = (Options = {}) => {
  return httpClient
    .get('/api/products/product-assemblies', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  find,
  update,
  destroy,
  storePhoto,
  getPhoto,
  category,
  unitmeasure,
  inventorytype,
  assemblyProduct
}
